<template>
    <div class="cookie-info">
        <div class="cookie-info-message"><p>Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.</p><p>Weitere Informationen zu Cookies erhalten Sie in unserer <router-link :to="{ name: 'Datenschutz' }">Datenschutzerklärung</router-link></p></div>
        <div class="close-cookie-info">
            <p @click="this.closeInfo">Fortfahren</p></div>
    </div>
</template>
<script>
export default {
  name: "CookieInfo",
  methods:{
      closeInfo(){
          console.log("click")
          this.$emit("closeInfo")
      }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/interface/CookieInfo/CookieInfo.vue